const precise_round = (num, dec) => {
    if ((typeof num !== 'number') || (typeof dec !== 'number')) 
        return false; 

    var num_sign = num >= 0 ? 1 : -1;

    return (Math.round((num*Math.pow(10,dec))+(num_sign*0.0001))/Math.pow(10,dec)).toFixed(dec);
}

const getDiscountsByType = (type, discounts, otherDiscounts) =>{
    let list = [];

    if(type == 'DERECHOENSEÑANZA' && discounts){
        for(var i = 0; i < discounts.length; i++) {
            discounts[i].item = 'DERECHOENSEÑANZA';
            discounts[i].quotas_payment = 'AMBOS';
            discounts[i].discount_type = 'PORCENTAJE';
            discounts[i].percentage = Number(discounts[i].discount_percentage).toFixed(0);
            discounts[i].status = true;
            list.push(discounts[i]);
        }
    }
    
    if(otherDiscounts){
        for(var j = 0; j < otherDiscounts.length; j++) {
            if(otherDiscounts[j].item == type) {
                list.push(otherDiscounts[j]);
            }
        }
    }

    return list; 
}

const getDiscount = (element, course, book) => {
    let discount = 0;

    if(element.item == "LIBRO"){
        if(element.discount_type == 'PORCENTAJE') {
            discount = (book * element.percentage) / 100;
        } else {
            discount = element.amount;
        }
    } else {
        if(element.discount_type == 'PORCENTAJE') {
            discount = (course * element.percentage) / 100;
        } else {
            discount = element.amount;
        }
    }
  
    return discount;
}

export default {
    precise_round,
    getDiscountsByType,
    getDiscount
};